import React, { useState } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DatePicker from "react-datepicker";
import Slide from "@material-ui/core/Slide";
import filterImage from "../../../images/filterImg.png";
import { setPeriodStoreSingle } from "../Utility/action";
import {
  setSelectedFromPeriod,
  setSelectedToPeriod,
  setSelectedIssueDate,
  setSelectedDueDate,
  getNoticeTableData,
  setNoticeTypeCodeFilterList,
  setReferenceIdFilterList,
} from "./action";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Chip,
} from "@material-ui/core";
import SelectMenu from "./SelectMenu";
import "../style.css";
import { formatDateToDDMMYYYY } from "../Utility/utilis";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function Filter({ open, onClose, getTableData }) {
  const {
    refIdsList,
    noticeTypeList,
    selectedFromPeriod,
    selectedToPeriod,
    selectedIssueDate,
    selectedDueDate,
    selectedDate,
    selectedGstin,
    noticeTypeCodeFilterList,
    referenceIdFilterList,
  } = useSelector((state) => state.noticeReducer);

  const dispatch = useDispatch();

  const handleFromPeriodChange = (date) => {
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let yr = date.getFullYear();
    let period = mnth + "-" + yr;
    dispatch(setPeriodStoreSingle(period));
    dispatch(setSelectedFromPeriod(date));
  };

  const handleToPeriodChange = (date) => {
    dispatch(setSelectedToPeriod(date));
  };

  const handleIssueDateChange = (e) => {
    dispatch(setSelectedIssueDate(e.target.value));
  };

  const handleDueDateChange = (e) => {
    dispatch(setSelectedDueDate(e.target.value));
  };

  const handleInputChange = (e) => {
    e.preventDefault();
  };

  // Notice Type Code Filter
  const noticeTypeCodeOptions = ["NTC123", "NTC456", "NTC789", "NTC321"];
  const [selectedNoticeTypeCode, setSelectedNoticeTypeCode] = useState(null);

  const handleAddNoticeTypeCode = () => {
    if (
      selectedNoticeTypeCode &&
      !noticeTypeCodeFilterList.includes(selectedNoticeTypeCode)
    ) {
      dispatch(setNoticeTypeCodeFilterList([
        ...noticeTypeCodeFilterList,
        selectedNoticeTypeCode,
      ]));
      setSelectedNoticeTypeCode(null); // Clear dropdown after adding
    }
  };

  const handleChipDelete = (index) => {
    const updatedList = [...noticeTypeCodeFilterList];
    updatedList.splice(index, 1);
    dispatch(setNoticeTypeCodeFilterList(updatedList));
  };

  // Reference ID Filter
  const referenceIdOptions = ["REF001", "REF002", "REF003", "REF004"];
  const [selectedReferenceId, setSelectedReferenceId] = useState(null);

  const handleAddReferenceId = () => {
    if (
      selectedReferenceId &&
      !referenceIdFilterList.includes(selectedReferenceId)
    ) {
      dispatch(setReferenceIdFilterList([...referenceIdFilterList, selectedReferenceId]));
      setSelectedReferenceId(null); // Clear dropdown after adding
    }
  };

  const handleReferenceChipDelete = (index) => {
    const updatedList = [...referenceIdFilterList];
    updatedList.splice(index, 1);
    dispatch(setReferenceIdFilterList(updatedList));
  };

  const [selectedNoticeTypes, setSelectedNoticeTypes] = useState([]);
  const [selectedMarkStatuses, setSelectedMarkStatuses] = useState([]);
  const [selectedFetchStatus, setSelectedFetchStatus] = useState([]);

  const noticeTypeOptions = [
    { label: "Personal Hearing", value: "Personal Hearing" },
  ];

  const markStatusOptions = [
    { label: "Closed", value: "Closed" },
    { label: "Reply-Filled", value: "Reply-Filled" },
    { label: "In Progress", value: "In Progress" },
  ];
  const fetchStatusOptions = [
    { label: "Completed", value: "Completed" },
    { label: "Failed", value: "Failed" },
    { label: "In-Progress", value: "In-Progress" },
  ];

  const handleApplyFilters = async () => {
    await getTableData(1, "", true);
    onClose();
  };
  const handleClearFilters = async () => {
    const formattedDate = formatDateToDDMMYYYY(selectedDate);
    const filters = {
      mode: "note",
      gstin: selectedGstin,
      periodMonth: formattedDate,
      page: 1,
      pageSize: 10,
      q: "",
      fromPeriod: null,
      toPeriod: null,
      issueDate: "",
      dueDate: "",
    };
    await dispatch(getNoticeTableData(filters));
    // Clear all filter states here
    dispatch(setNoticeTypeCodeFilterList([]));
    dispatch(setReferenceIdFilterList([]));
    setSelectedNoticeTypes([]);
    setSelectedNoticeTypeCode(null);
    setSelectedReferenceId(null);
    setSelectedMarkStatuses([]);
    setSelectedFetchStatus([]);
    dispatch(setSelectedFromPeriod(null));
    dispatch(setSelectedToPeriod(null));
    dispatch(setSelectedIssueDate(''));
    dispatch(setSelectedDueDate(''));
    onClose();
  };
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      // Prevent closing the dialog on backdrop click or Escape key press
      return;
    }
    onClose();
  };
  return (
    <Dialog
      className="filterModal"
      TransitionComponent={Transition}
      keepMounted
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth="sm"
    >
      <div
        style={{
          position: "absolute",
          top: "6px",
          left: "-26px",
          cursor: "pointer",
        }}
        onClick={handleClearFilters}
      >
        <img src={filterImage} alt="filter" width="100px" height="40px" />
        <span
          style={{
            position: "absolute",
            top: "8px",
            left: "36px",
            fontSize: "12px",
            color: "white",
          }}
        >
          Filters
        </span>
      </div>
      <DialogTitle
        id="alert-dialog-slide-title"
        style={{ display: "flex", justifyContent: "end" }}
      >
        <Button
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            padding: "5px 45px",
            fontSize: "10px",
            marginRight: "10px",
            textTransform:'capitalize'
          }}
          onClick={handleClearFilters}
        >
          Clear Filters
        </Button>
        <Button
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            padding: "5px 45px",
            fontSize: "10px",
            textTransform:'capitalize'
          }}
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
      </DialogTitle>
      <DialogContent>
        <div className="filter-select-period">
          <div className="filter-from-period">
            <InputLabel
              className="text_label"
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
                color: "black",
                top: "10px",
              }}
            >
              Select From Period
            </InputLabel>
            <DatePicker
              showMonthYearPicker
              dateFormat="MMM-yyyy"
              placeholderText="Select Period"
              onChange={handleFromPeriodChange}
              selected={selectedFromPeriod}
              popperClassName="custom-datepicker-popper"
              calendarClassName="custom-datepicker-calendar"
              onKeyDown={handleInputChange}
              onKeyPress={handleInputChange}
            />
          </div>

          <div className="filter-to-period">
            <InputLabel
              className="text_label"
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
                color: "black",
                top: "10px",
              }}
            >
              Select To Period
            </InputLabel>
            <DatePicker
              showMonthYearPicker
              dateFormat="MMM-yyyy"
              placeholderText="Select Period"
              onChange={handleToPeriodChange}
              selected={selectedToPeriod}
              popperClassName="custom-datepicker-popper"
              calendarClassName="custom-datepicker-calendar"
              onKeyDown={handleInputChange}
              onKeyPress={handleInputChange}
            />
          </div>
        </div>

        <div className="filter-date">
          <div className="filter-date-of-issue">
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            >
              Date of Issue
            </label>
            <TextField
              id="date"
              type="date"
              value={selectedIssueDate}
              onChange={handleIssueDateChange}
              style={{
                width: "75%",
                marginTop: "-10px",
                backgroundColor: "white",
              }}
            />
          </div>
          <div className="filter-due-date-of-reply">
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            >
              Due Date of Reply
            </label>
            <TextField
              id="date"
              type="date"
              value={selectedDueDate}
              onChange={handleDueDateChange}
              style={{
                width: "70%",
                marginTop: "-10px",
                backgroundColor: "white",
              }}
            />
          </div>
        </div>

        <div
          style={{
            padding: "10px 8px",
            backgroundColor: "#F9F5FF",
            height: "110px",
            marginTop: "10px",
            borderRadius: "5px",
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ fontWeight: "800", fontSize: "15px", width: "30%" }}>
              Notice Type
            </div>
            <div
              style={{
                width: "70%",
                marginLeft: "5px",
                height: "50px",
                overflowY: "scroll",
              }}
            >
              {noticeTypeCodeFilterList.map((noticeTypeCode, i) => (
                <Chip
                  key={i}
                  label={noticeTypeCode}
                  clickable
                  color="primary"
                  style={{
                    backgroundColor: "rgb(220 197 255)",
                    color: "rgb(84 53 131)",
                    margin: "3px 3px",
                  }}
                  onDelete={() => handleChipDelete(i)}
                />
              ))}
            </div>
          </div>

          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label
                htmlFor="filled-adornment-notice-type-code"
                style={{ fontSize: "8px", margin: "0px" }}
              >
                Notice Type
              </label>
              <Autocomplete
                options={noticeTypeList}
                id="auto-complete-notice-type-code"
                value={selectedNoticeTypeCode}
                onChange={(event, newValue) => {
                  setSelectedNoticeTypeCode(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>

            <Button
              onClick={handleAddNoticeTypeCode}
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                fontSize: "10px",
                width: "15%",
                marginLeft: "8px",
                marginTop: "10px",
                height: "30px",
                textTransform:'capitalize'
              }}
            >
              + Add
            </Button>
          </div>
        </div>

        <div
          style={{
            padding: "10px 8px",
            backgroundColor: "#F9F5FF",
            height: "110px",
            marginTop: "10px",
            borderRadius: "5px",
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ fontWeight: "800", fontSize: "15px", width: "30%" }}>
              Reference ID
            </div>
            <div
              style={{
                width: "70%",
                marginLeft: "5px",
                height: "50px",
                overflowY: "scroll",
              }}
            >
              {referenceIdFilterList.map((refId, i) => (
                <Chip
                  key={i}
                  label={refId}
                  clickable
                  color="primary"
                  style={{
                    backgroundColor: "rgb(220 197 255)",
                    color: "rgb(84 53 131)",
                    margin: "3px 3px",
                  }}
                  onDelete={() => handleReferenceChipDelete(i)}
                />
              ))}
            </div>
          </div>

          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label
                htmlFor="filled-adornment-ref"
                style={{ fontSize: "8px", margin: "0px" }}
              >
                Reference ID
              </label>
              <Autocomplete
                options={refIdsList}
                id="auto-complete-ref"
                value={selectedReferenceId}
                onChange={(event, newValue) => {
                  setSelectedReferenceId(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>

            <Button
              onClick={handleAddReferenceId}
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                fontSize: "10px",
                width: "15%",
                marginLeft: "8px",
                marginTop: "10px",
                height: "30px",
                textTransform:'capitalize'
              }}
            >
              + Add
            </Button>
          </div>
        </div>
        {/* <div
                    style={{
                        padding: "10px 8px",
                        backgroundColor: "#F9F5FF",
                        height: "100px",
                        marginTop: "10px",
                        borderRadius: "5px",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ fontWeight: "800", fontSize: "15px", width: "40%" }}>
                            Notice Type
                        </div>
                        <div style={{ fontWeight: "800", fontSize: "15px", width: "40%" }}>
                            Mark Status
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between" }} className="filter-text-input">
                        <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
                            <label
                                htmlFor="filled-adornment-notice"
                                style={{ fontSize: "8px", margin: "0px" }}
                            >
                                Notice Type
                            </label>
                            <Autocomplete
                                options={noticeTypeList}
                                id="auto-complete-notice"
                                value={selectedNoticeTypes}
                                onChange={(event, newValue) => {
                                    setSelectedNoticeTypes(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        style={{ backgroundColor: "#eaeaea" }}
                                    />
                                )}
                            />
                        </FormControl>

                        <div className="dropdown-container-gstr6 document-type-filter" style={{ width: "40%" }}>
                            <SelectMenu
                                options={markStatusOptions}
                                handleChange={(e) => setSelectedMarkStatuses(e.target.value)}
                                selectedValue={selectedMarkStatuses}
                                multiple={true}
                            />
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        padding: "10px 8px",
                        backgroundColor: "#F9F5FF",
                        height: "100px",
                        marginTop: "10px",
                        borderRadius: "5px",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ fontWeight: "800", fontSize: "15px", width: "40%" }}>
                            Fetch Status
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between" }} className="filter-text-input">
                        <div className="dropdown-container-gstr6 document-type-filter" style={{ width: "40%" }}>
                            <SelectMenu
                                options={fetchStatusOptions}
                                handleChange={(e) => setSelectedFetchStatus(e.target.value)}
                                selectedValue={selectedFetchStatus}
                                multiple={true}
                            />
                        </div>

                    </div>
                </div> */}
      </DialogContent>
    </Dialog>
  );
}
